import { BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import { useModule } from '../../../../../../hooks/module/module';
import { useCandidateInterview } from '../../hook/useCandidateInterview';

function ConfirmGenerateCertificate({
  initialDate,
  finalDate,
  cargaHoraria,
  seminarType,
}) {
  const { formatDate } = useCandidateInterview();
  const { moduleSelected } = useModule();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        padding: '20px 0px',
      }}
    >
      <BaSeParagraph>
        Tem certeza que deseja gerar o(s) certificado(s) para o(s) candidato(s)?
      </BaSeParagraph>
      <div>
        <BaSeParagraph>
          As datas definidas de realização do seminário foram:{' '}
        </BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          Data de início: {formatDate(new Date(initialDate))}
        </BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          Data de término: {formatDate(new Date(finalDate))}
        </BaSeParagraph>
      </div>
      <div>
        <BaSeParagraph>E a carga horária informada foi de: </BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {cargaHoraria}h
        </BaSeParagraph>
      </div>

      {moduleSelected?.id === 1 && (
        <div>
          <BaSeParagraph>Tipo de seminário: </BaSeParagraph>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {seminarType}
          </BaSeParagraph>
        </div>
      )}
    </div>
  );
}

export default ConfirmGenerateCertificate;
